import { defineComponent as _defineComponent } from 'vue'
import { computed, getCurrentInstance, ref, unref } from 'vue';
import ComplianceSummaryRow from './ComplianceSummaryRow.vue';
import ComplianceMappingRow from './ComplianceMappingRow.vue';
import ExpandToggleButton from '@/_core/shared/ui/ExpandToggleButton/ExpandToggleButton.vue';
import type {
  TComplianceRequirement,
  TComplianceRequirementItem,
  TComplianceSummary,
  TComplianceMappingsResponse,
} from '@/_core/entities/report/models/types';


export default /*#__PURE__*/_defineComponent({
  __name: 'ReportComplianceRequirements',
  props: {
    summary: null,
    mappings: null,
    mode: null,
    isLoading: { type: Boolean },
    integrationId: null,
    selectedRequirementId: null,
    selectedItemId: null
  },
  emits: ["viewFindings"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'viewFindings', payload: { requirementId: string; itemId?: string }): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  summary?: TComplianceSummary;
  mappings?: TComplianceMappingsResponse;
  mode?: 'summary' | 'mappings';
  isLoading: boolean;
  integrationId?: string;
  selectedRequirementId?: string;
  selectedItemId?: string;
};





const isMappingsMode = computed(() => props.mode === 'mappings');

const widgetInstance = getCurrentInstance();
const complianceScopeRoute = computed(() => {
  if (!props.integrationId) return null;
  const currentPath = unref(widgetInstance?.proxy.$route)?.fullPath ?? '';
  const from = currentPath ? `?from=${encodeURIComponent(currentPath)}` : '';
  return `/integration/${props.integrationId}/settings/compliance-scope${from}`;
});

const expanded = ref<Record<string, boolean>>({});

const requirements = computed(() => {
  if (isMappingsMode.value) return props.mappings?.requirements ?? [];
  return props.summary?.requirements ?? [];
});

const allExpanded = computed(
  () => requirements.value.length > 0 && requirements.value.every((r) => expanded.value[r.id])
);

function toggle(id: string) {
  expanded.value = { ...expanded.value, [id]: !expanded.value[id] };
}

function toggleAll() {
  if (allExpanded.value) {
    expanded.value = {};
  } else {
    const next: Record<string, boolean> = {};
    for (const r of requirements.value) next[r.id] = true;
    expanded.value = next;
  }
}

const SUMMARY_HEADER_GRID =
  'tw:grid-cols-[1.5rem_minmax(10rem,1fr)_4rem_minmax(10rem,22rem)_6rem] ' +
  'tw:max-[890px]:grid-cols-[1.5rem_minmax(0,1fr)_7rem_9rem] ' +
  'tw:max-[576px]:grid-cols-[1.5rem_minmax(0,1fr)_auto_auto]';

const MAPPINGS_HEADER_GRID =
  'tw:grid-cols-[1.5rem_minmax(10rem,1fr)_minmax(16rem,24rem)] tw:max-[500px]:hidden';

return { __sfc: true,props, emit, isMappingsMode, widgetInstance, complianceScopeRoute, expanded, requirements, allExpanded, toggle, toggleAll, SUMMARY_HEADER_GRID, MAPPINGS_HEADER_GRID, ComplianceSummaryRow, ComplianceMappingRow, ExpandToggleButton }
}

})